export const screenPath = '/ReactMyAccountSecurity/';
export const screenDetailsPath = '/ReactMyAccountSecurity/Security/';
export const screenName = 'Security';
export const screenDetailsName = 'SecurityDetails';
